import { useAppDispatch } from 'store/hooks';
import { closeModal } from 'features/modal/modalSlice';
import { useTranslation } from 'react-i18next';
import { usePermissions } from 'features/permissions/usePermissions';
import { PermissionTypes } from 'features/permissions/types';
import { useEffect } from 'react';
import ConfirmationDialog from 'components/ConfirmationDialog';
import { bulkRejectEntry } from 'features/users/actions';

const RejectAllWaitingParticipants = () => {
  const { t } = useTranslation('modals');
  const dispatch = useAppDispatch();

  const { hasPermissions } = usePermissions();

  const canControlRoomEntry = hasPermissions(PermissionTypes.controlRoomEntry);

  useEffect(() => {
    if (!canControlRoomEntry) {
      dispatch(closeModal('rejectAllWaitingParticipants'));
    }
  }, [canControlRoomEntry, dispatch]);

  const handleOk = () => {
    dispatch(bulkRejectEntry());
    dispatch(closeModal('rejectAllWaitingParticipants'));
  };

  const handleCancel = () => {
    dispatch(closeModal('rejectAllWaitingParticipants'));
  };

  return (
    <ConfirmationDialog
      open
      title={t('reject_all_waiting_participants_confirmation.title')}
      description={t('reject_all_waiting_participants_confirmation.description')}
      cancelText={t('reject_all_waiting_participants_confirmation.btn_cancel_label')}
      okText={t('reject_all_waiting_participants_confirmation.btn_ok_label')}
      onOk={handleOk}
      onCancel={handleCancel}
    />
  );
};

export default RejectAllWaitingParticipants;
